import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchData,
  fetchPeriods,
} from "../../../../../features/fetch/fetchSlice";
import { Divider, Dropdown, Form, Table } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { save } from "../../../../../features/save/saveSlice";
import svg27 from "../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../assets/svg/svg12.svg";
import svg46 from "../../../../../assets/svg/svg46.svg";
import svg15 from "../../../../../assets/svg/svg15.svg";
import svg29 from "../../../../../assets/svg/svg29.svg";
import { setActiveObj } from "../../../../../features/obj/objSlice";
import toast from "react-hot-toast";
import moment from "moment";
import CardLoading from "../../../../../components/CardLoading";
import ConfirmModal from "../../../../../components/ConfirmModal";
import { formatText } from "../../../../../utils";

function ServicePerfList({perfType,perfId,index}) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "performance_metric_value/fetch_performancemetricvalues";


  const { loading, data, activeObjSchemes, periods, count } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      periods: state.fetch.periods,
      activeObjSchemes: state.obj.activeObj["privateSchemes"],
    })
  );
  const { refetchKey } = useSelector((state) => state.global);

  const [prodd, setProdd] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "serv/delete",
        irrismId: prodd?.irrismId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
  await dispatch(setActiveObj({ key: perfType, data: prodd }));
  await navigate(`/rob/scheme/servicePerf-add-form?tab=${index + 1}&perfType=${perfType}`);
};
 
  const handleAdd = async () => {
    await dispatch(setActiveObj({key: perfType , data: { perfType }}));
   await navigate(`/rob/scheme/servicePerf-add-form?tab=${index + 1}&perfType=${perfType}`);
  };
  const handleView = async () => {
   await dispatch(setActiveObj({ key: perfType, data: prodd }));
    await navigate(`/rob/serviceperf-view?tab=${index + 1}&perfType=${perfType}`);
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: perfType, data: item }));
    await navigate(`/rob/serviceperf-view?tab=${index + 1}&perfType=${perfType}`);
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg46} alt="svg46" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "10px",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Date",
      dataIndex: "mvalCode",
      render: (text, item) => (
        <span className="cursor-pointer" onClick={() => handleViewName(item)}>
          {text ? moment(text).format("DD-MM-YYYY  HH:mm:ss") : "--"}
        </span>
      ), 
    },

      {
      title: "Created By",
      dataIndex: "createdByName", 
    },

    

    {
      title: "Actions",
      align: "right",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        mvalSchId: activeObjSchemes?.schId,
        perfType:perfType,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }
 
useEffect(() => {
  fetchTableData();
}, []);  

useEffect(() => {
  if (refetchKey === String(index + 1)) {
    fetchTableData();
  }
}, [refetchKey]);


  if (loading) return <CardLoading />;
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="form-add-h">Available {formatText(perfType)}</div>
        <div className="w-[100px]">
          <button onClick={() => handleAdd()} className="cstm-btn-2">
            <img src={svg29} alt="svg29" /> <span className="">Add</span>
          </button>
        </div>
      </div>

      <Table
        rowSelection={false}
        className="mt-[1.31rem] w-full"
        scroll={{
          x: 1200,
        }}
        rowKey={(record) => record?.irrismId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default ServicePerfList;
